import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=cefd92b8"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
import style0 from "./Staff.vue?vue&type=style&index=0&id=cefd92b8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cefd92b8')) {
      api.createRecord('cefd92b8', component.options)
    } else {
      api.reload('cefd92b8', component.options)
    }
    module.hot.accept("./Staff.vue?vue&type=template&id=cefd92b8", function () {
      api.rerender('cefd92b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Staff.vue"
export default component.exports